import { StyledToolTip, ToolTipContainer } from './styles';

export const ToolTipSection = () => {
  return (
    <ToolTipContainer>
      <StyledToolTip
        anchorText="Capsule is available in other cities."
        header="Capsule is available in other cities."
        body="Add your delivery address to your account or chat with us to see if we deliver to another location."
        analyticTip="I moved cities or am on vacation"
        placement="top-start"
        textSize="small"
      />
    </ToolTipContainer>
  );
};
